angular.module('impactx.panel').directive('ixCatalogPanel', function () {
    return {
        restrict: 'EA',
        controller: 'CatalogPanelCtrl',
        controllerAs: 'catalogPanelCtrl',
        scope: true,
        bindToController: {
            catalog: "=",
            catalogRedirect: "@",
            noSupplierLink: "=",
            currentFilter: "="
        },
        templateUrl: 'shared/panel/templates/catalog.panel.tmpl.html'
    }
});